import React from 'react';
import { BubbleButton } from '@go-client/components/BubbleUI';
import Page from './Page';

import './NotFound404.scss';

export default function NotFound404() {
  return (
    <Page className="NotFoundPage">
      <div className="h-full grid items-center justify-center">
        <div className="shadow-xl" style={{ width: '400px' }}>
          <div className="aspect-wide bg-ocean logo"></div>
          <div className="p-8 bg-white">
            <h1 className="text-xl mb-3">Page Not Found</h1>
            <div className="bg-eggshell border rounded px-4 py-3 mb-5">
              <p>
                The page you have requested does not exist or cannot be found. Please click the
                button below to be redirected to the home page.
              </p>
            </div>
            <BubbleButton variant="slate" linkProps={{ to: '/' }} icon="home">
              Go Home
            </BubbleButton>
          </div>
        </div>
      </div>
    </Page>
  );
}
